export const DRAWER_WIDTH = 400
export const DRAWER_CONTENTS_PADDING = 32
export const DRAWER_TRANSITION_DURATION_MS = 500
